export const FadeCarousel = ({ images, current, alt, imgClassName = "", testId }) => (
  <div className="absolute inset-0">
    {images.map((src, i) => {
      const active = i === current;
      return (
        <img
          key={src}
          src={src}
          alt={`${alt} ${i + 1}`}
          loading="eager"
          decoding="async"
          aria-hidden={!active}
          data-testid={active ? testId : undefined}
          className={`fade-slide absolute inset-0 m-auto max-w-full max-h-full w-auto h-auto object-contain ${imgClassName} ${
            active ? "opacity-100 scale-100" : "opacity-0 scale-[0.97] pointer-events-none"
          }`}
        />
      );
    })}
  </div>
);
